// CORE
import { Form } from '@autoprog/core-client';

// TEMPLATE
import T_modal from '../../../tpl/modals/editPage/detailsBill.html';

// LIBS
import Modal from '@libs/Modal';

// CUSTOM_ELEMENT
import CE_Select2 from '@libs/customElement/Select2';

type DetailsBillData = {
	infos: {
		type: string
	}
};

class DetailsBill extends Modal {
	private selectPostinit: { [key: string]: CE_Select2 } = {};

	private form: Form | null;

	constructor(data: DetailsBillData) {
		super({
			tpl: T_modal,
			keyboard: false,
			backdrop: 'static'
		});

		this.form = null;

		this.on('opened', async () => {
			this.form = new Form(this.element.querySelector('form') as HTMLFormElement);

			await this.setData(data);
			this.postInit();

			const N_save = this.element.querySelector('#save') as HTMLButtonElement;

			N_save.addEventListener('click', async () => {
				N_save.loading(new Promise(async () => {
					const data = this.form?.getData() as { [key: string]: any };
					this.resolve(data);
				}));
			});
		});
	}

	private async setData(data: DetailsBillData) {
		const res: { [key: string]: any } = {
			infos: {
				type: data.infos.type
			}
		};

		this.form?.setData(res);
	}

	private postInit() {
		for (const key in this.selectPostinit) {
			this.selectPostinit[key].postInit();
		}
	}
}

export default DetailsBill;
